/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import {
  BlockTransition,
  ChangeRouteFn,
  ReplaceRouteFn,
} from './BlockTransition';

type GlobalRouterProps = {
  children: React.ReactNode;
};

type Context = {
  isTransitionBlocked: boolean;
  gotoRoute: ChangeRouteFn;
  replaceRoute: ReplaceRouteFn;
};

export const RouterContext = createContext<Context>(null as any);

/*
  GlobalRouter is used to to share the state of the navigation to the entire app
  and to give a way to a children deep inside the render tree to navigate.
  And that navigation is cancelable because of BlockingTransition.
*/

/*
  <Redirect /> and `history.push` is not used directly because we have no way
  to cancel them without handling it manually every single time.
*/
export function GlobalRouter({ children }: GlobalRouterProps) {
  return (
    <Router>
      <Route
        render={(routerContext) => (
          <BlockTransition {...routerContext}>
            {(isBlocking, changeRoute, replaceRoute) => (
              <RouterContext.Provider
                value={{
                  isTransitionBlocked: isBlocking,
                  gotoRoute: changeRoute,
                  replaceRoute: replaceRoute,
                }}
              >
                {children}
              </RouterContext.Provider>
            )}
          </BlockTransition>
        )}
      />
    </Router>
  );
}
